import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGroupPic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.197 21.167h9.606c2.53 0 3.539-1.55 3.658-3.438l.477-7.571A3.44 3.44 0 0 0 17.5 6.5c-.56 0-1.073-.32-1.33-.815l-.66-1.33c-.42-.834-1.52-1.521-2.456-1.521h-2.099c-.944 0-2.044.687-2.466 1.521l-.66 1.33c-.257.495-.77.815-1.329.815a3.44 3.44 0 0 0-3.438 3.658l.477 7.572c.11 1.888 1.128 3.437 3.658 3.437Zm3.428-12.833h2.75"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 17.5a2.986 2.986 0 0 0 2.98-2.98A2.986 2.986 0 0 0 12 11.541a2.985 2.985 0 0 0-2.979 2.98 2.985 2.985 0 0 0 2.98 2.979Z"
    />
  </svg>
);
export default SvgGroupPic;
